import { SelectHTMLAttributes, forwardRef } from 'react';

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label: string;
  options: { value: string; label: string }[];
  error?: string;
  helper?: string;
}

const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ label, options, error, helper, className = '', ...props }, ref) => {
    return (
      <div className="mb-4">
        <label className="block text-gray-700 font-medium mb-1.5" htmlFor={props.id}>
          {label}
          {props.required && <span className="text-accent-600 ml-1">*</span>}
        </label>
        
        <select
          ref={ref}
          className={`w-full px-3 py-2 border ${
            error ? 'border-accent-500' : 'border-gray-300'
          } rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all bg-white ${className}`}
          {...props}
        >
          <option value="">Select an option</option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        
        {error ? (
          <p className="mt-1 text-sm text-accent-600">{error}</p>
        ) : helper ? (
          <p className="mt-1 text-sm text-gray-500">{helper}</p>
        ) : null}
      </div>
    );
  }
);

Select.displayName = 'Select';

export default Select;